/* eslint-disable max-len */
/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import AddASE from './AddASE';
import ListASE from './ListASE';

export default function AssignASE({
    OrderDetails, setOrderDetails, distributorDetails, handleAddASE,
}) {
    return (
        <>
            {((Number(OrderDetails?.work_flow_status) < 2 && ['Trade', 'Trade EUB'].includes(OrderDetails.order_type)) || (!['Trade', 'Trade EUB'].includes(OrderDetails.order_type) && OrderDetails.ASEs.length === 0) || (!['Trade', 'Trade EUB'].includes(OrderDetails.order_type) && (OrderDetails.ASEs.length === 1 && OrderDetails.ASEs[0] === null)))
            && (<AddASE
                OrderDetails={OrderDetails}
                setOrderDetails={setOrderDetails}
                distributorDetails={distributorDetails}
                handleAddASE={handleAddASE}
            />)}
            {OrderDetails.ASEs.length > 0 && !(OrderDetails?.ASEs?.length === 1 && OrderDetails?.ASEs[0] === null)
                && <ListASE OrderDetails={OrderDetails} setOrderDetails={setOrderDetails} />}
        </>
    );
}
